module.exports = "<div class=\"col-lg-12 col-md-12 col-12 px-0\">\n  <app-header></app-header>\n</div>\n\n<div class=\"col-lg-12 col-md-12 col-12 px-0 pb-2 app-cont-bg\">\n  <router-outlet></router-outlet>\n</div>\n\n<div class=\"col-lg-12 col-md-12 col-12 px-0\">\n  <app-footer></app-footer>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// D:/pokpak-v3/pokpak-v2/pokpak-ang/src/app/home-page/home-page.component.html
// module id = ../../../../../src/app/home-page/home-page.component.html
// module chunks = main